module.exports = require('./globals.json');



/*****************
 ** WEBPACK FOOTER
 ** ./~/globals/index.js
 ** module id = 320
 ** module chunks = 0
 **/